import { render, staticRenderFns } from "./myApi.vue?vue&type=template&id=8c99e63c&"
import script from "./myApi.vue?vue&type=script&lang=js&"
export * from "./myApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports